import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ExportWarehouseMember } from 'contracts/WarehouseMembers';
import type { Pagination } from 'contracts/Pagination';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data', 'pagination'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'EXPORT_WAREHOUSE_MEMBERS_',
  }
);

export interface ExportWarehouseMembersState {
  data: ExportWarehouseMember[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface ExportWarehouseMembersRequestAction {
  query?: Record<string, any>;
  onSuccess?: (data: any) => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ExportWarehouseMember[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ExportWarehouseMembersState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ExportWarehouseMembersState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ExportWarehouseMembersState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ExportWarehouseMembersState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ExportWarehouseMembersState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const exportWarehouseMembers = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ExportWarehouseMembersTypes = Types;
export const ExportWarehouseMembersActions = Creators;
